module.exports = __webpack_public_path__ + "static/media/favicon.269807bc.ico";